<div class="trading-dashboard">
    <!-- Filter / header bar -->
    <div class="filters-card">
        <div class="filters-top-row">
            <h2>Trading P&amp;L</h2>

            <div class="net-summary" *ngIf="pnlRows && pnlRows.length">
                <span class="label">Total Net Cashflow:</span>
                <span class="value" [ngClass]="{ positive: netTotal >= 0, negative: netTotal < 0 }">
                    {{ netTotal | number: '1.2-2' }}
                </span>
            </div>
        </div>

        <div class="filters-grid">
            <div class="field">
                <label for="startDate">Start Date</label>
                <input id="startDate" type="date" [(ngModel)]="startDate" name="startDate" required />
            </div>

            <div class="field">
                <label for="endDate">End Date</label>
                <input id="endDate" type="date" [(ngModel)]="endDate" name="endDate" required />
            </div>

            <div class="field">
                <label for="exchange">Exchange</label>
                <select id="exchange" [(ngModel)]="exchange" name="exchange">
                    <option value="">All Exchanges</option>
                    <option value="Coinbase">Coinbase</option>
                    <option value="STS">STS</option>
                    <option value="Wintermute">Wintermute</option>
                </select>
            </div>

            <div class="field">
                <label for="productId">Product</label>
                <select id="productId" [(ngModel)]="productId" name="productId">
                    <option value="">All Products</option>
                    <option value="BTC-USD">BTC</option>
                    <option value="ETH-USD">ETH</option>
                    <option value="SOL-USD">SOL</option>
                </select>
            </div>


            <div class="field button-field">
                <button type="button" (click)="loadPnl()" [disabled]="loading">
                    {{ loading ? 'Loading…' : 'Load P&L' }}
                </button>
            </div>
        </div>
    </div>

    <!-- Summary sections (only when we have data and not loading) -->
    <div class="summary-grid" *ngIf="!loading && pnlRows && pnlRows.length">
        <!-- Daily P&L summary -->
        <div class="summary-card">
            <h3>Daily Net P&amp;L</h3>
            <table class="summary-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Net P&amp;L</th>
                        <th>Buy Notional</th>
                        <th>Sell Notional</th>
                        <th>Fees</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let d of dailySummary">
                        <td>{{ d.tradeDate }}</td>
                        <td [ngClass]="{ positive: d.netCashFlow >= 0, negative: d.netCashFlow < 0 }">
                            {{ d.netCashFlow | number:'1.2-2' }}
                        </td>
                        <td class="num">{{ d.totalBuyNotional | number:'1.2-2' }}</td>
                        <td class="num">{{ d.totalSellNotional | number:'1.2-2' }}</td>
                        <td class="num">{{ d.totalFees | number:'1.2-2' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- P&L by product -->
        <div class="summary-card">
            <h3>P&amp;L by Product</h3>
            <table class="summary-table">
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Base</th>
                        <th>Quote</th>
                        <th>Net P&amp;L</th>
                        <th>Fees</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let p of productSummary">
                        <td>{{ p.productId }}</td>
                        <td>{{ p.baseCurrency }}</td>
                        <td>{{ p.quoteCurrency }}</td>
                        <td [ngClass]="{ positive: p.netCashFlow >= 0, negative: p.netCashFlow < 0 }">
                            {{ p.netCashFlow | number:'1.2-2' }}
                        </td>
                        <td class="num">{{ p.totalFees | number:'1.2-2' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- P&L by exchange -->
        <div class="summary-card">
            <h3>P&amp;L by Exchange</h3>
            <table class="summary-table">
                <thead>
                    <tr>
                        <th>Exchange</th>
                        <th>Net P&amp;L</th>
                        <th>Fees</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let e of exchangeSummary">
                        <td>{{ e.exchange }}</td>
                        <td [ngClass]="{ positive: e.netCashFlow >= 0, negative: e.netCashFlow < 0 }">
                            {{ e.netCashFlow | number:'1.2-2' }}
                        </td>
                        <td class="num">{{ e.totalFees | number:'1.2-2' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Status messages -->
    <div class="status" *ngIf="loading">
        Loading P&amp;L…
    </div>

    <div class="status error" *ngIf="error">
        {{ error }}
    </div>

    <div class="status" *ngIf="!loading && (!pnlRows || !pnlRows.length) && !error">
        No data for the selected range.
    </div>

    <!-- Detail table -->
    <div class="table-wrapper" *ngIf="!loading && pnlRows && pnlRows.length">
        <table class="pnl-table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Exchange</th>
                    <th>Product</th>
                    <th>Base</th>
                    <th>Quote</th>
                    <th>Buy Size</th>
                    <th>Sell Size</th>
                    <th>Buy Notional</th>
                    <th>Sell Notional</th>
                    <th>Fees</th>
                    <th>Net Cashflow</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of pnlRows">
                    <td>{{ row.tradeDate | date:'yyyy-MM-dd' }}</td>
                    <td>{{ row.exchange }}</td>
                    <td>{{ row.productId }}</td>
                    <td>{{ row.baseCurrency }}</td>
                    <td>{{ row.quoteCurrency }}</td>
                    <td class="num">{{ row.totalBuySize | number:'1.6-6' }}</td>
                    <td class="num">{{ row.totalSellSize | number:'1.6-6' }}</td>
                    <td class="num">{{ row.totalBuyNotional | number:'1.2-2' }}</td>
                    <td class="num">{{ row.totalSellNotional | number:'1.2-2' }}</td>
                    <td class="num">{{ row.totalFees | number:'1.2-2' }}</td>
                    <td class="num" [ngClass]="{ positive: row.netCashFlow >= 0, negative: row.netCashFlow < 0 }">
                        {{ row.netCashFlow | number:'1.2-2' }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>